import * as React from 'react';

const ClearFacetFilter = ({ onClear , isDisabled =false , label  })=>{
    const handleClick = ()=>{
        onClear();
        // [A11y] Once the filter is cleared, shift the focus to the active facet.
        const activeFacet = document.getElementById('activeFacet');
        activeFacet === null || activeFacet === void 0 ? void 0 : activeFacet.focus();
    };
    return /*#__PURE__*/ React.createElement("button", {
        className: "clear-facet-filter",
        onClick: handleClick,
        disabled: isDisabled,
        type: "button",
        "data-t": "clear-facet-trigger"
    }, label);
};

export { ClearFacetFilter, ClearFacetFilter as default };
//# sourceMappingURL=ClearFacetFilter.js.map
